<template>
  <v-main class="page-account">
    <AppBar/>
    <v-layout fill-height column>

      <v-container flex-fill fluid>
        <div class="account-title-block">
          <h3 class="tit">
            <span class="tit-point">휴대폰</span> 인증
          </h3>
          <p class="desc">사용자 인증을 진행해주세요</p>
        </div>
        <v-form class="form-item" ref="form" lazy-validation>

          <label class="label">이름 <span class="text--required">*</span></label>
          <div class="input-group">
            <v-text-field solo flat filled v-model="userName" :rules="userName_rule" maxlength="4" required
                          placeholder="이름 입력" v-bind:readonly="getClientCd() || confirmReadonly"/>
          </div>

          <label class="label">생년월일 <span class="text--required">*</span></label>
          <div class="input-group">
            <v-text-field solo flat filled v-model="birthday" :rules="birthday_rule" required readonly
                          placeholder="생년월일" @click="rollerPickerOpen"/>
          </div>

          <label class="label">성별 <span class="text--required">*</span></label>
          <div class="input-group">
            <v-radio-group
                v-model="gender"
                row
                class="radio-btn-group flex-grow-1"
                mandatory
                :readonly="getClientCd() || confirmReadonly"
            >
              <v-radio label="남자" value="01"></v-radio>
              <v-radio label="여자" value="02"></v-radio>
            </v-radio-group>
          </div>
<!--          <div class="input-group">-->
<!--            <v-btn-toggle v-model="gender"-->
<!--                          group-->
<!--                          class="btn-toggle-input-group flex-grow-1">-->
<!--              <v-btn depressed outlined :ripple="false"-->
<!--                     value="01"-->
<!--                     :disabled="getClientCd() || confirmReadonly"-->
<!--              >남자</v-btn>-->
<!--              <v-btn depressed outlined :ripple="false"-->
<!--                     value="02"-->
<!--                     :disabled="getClientCd() || confirmReadonly"-->
<!--              >여자</v-btn>-->
<!--            </v-btn-toggle>-->
<!--          </div>-->

          <label class="label">휴대전화 <span style="color: red;">*</span></label>
          <div class="input-group">
            <v-text-field solo flat filled v-model="phone" :rules="phone_rule" required placeholder="01012345678"
                          v-bind:readonly="getClientCd() || confirmReadonly"
                          maxlength="11"
                          oninput="javascript: this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"/>
            <v-btn depressed :ripple="false" color="primary" class="btn-input" width="115"
                   @click="doSendAuthCode">
              {{ btnText }}
            </v-btn>
          </div>
          <div class="input-group" v-show="doSendChk">
            <v-text-field maxlength="6" solo flat filled
                          v-model="authCode"
                          required
                          placeholder="인증번호를 입력해주세요"
                          oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '' );"
                          v-bind:readonly="successReadonly"
            >
              <template #append>
                <Timer ref="timer" @timeLimit="timeLimit"/>
              </template>
            </v-text-field>
            <v-btn depressed :ripple="false" color="primary" class="btn-input" width="115"
                   v-bind:disabled="isBtnAt"
                   @click="checkAuthCode">확인
            </v-btn>
          </div>
          <div class="px-3 mt-n2 mb-6" v-if="isBtnAt">
            <span class="light-blue--text fs-12" v-if="codeConfirm">{{ codeChkReturnMsg }}</span>
            <span class="error--text fs-12" v-else>{{ codeChkReturnMsg }}</span>
          </div>

        </v-form>
      </v-container>
      <v-footer grow color="transparent" class="content-footer">
        <div class="content-buttons">
          <BlackBtn x-large str="다음" v-bind:disabled="nextDisabled" @click="goNext"/>
        </div>
      </v-footer>
    </v-layout>
    <DateRollerPicker ref="rollerPicker" @selectValue="selectValue"/>
  </v-main>
</template>

<script>
import BlackBtn from "@/components/btns/BlackBtn"
import DateRollerPicker from "@/components/layout/bottomSheet/DateRollerPicker";
import Timer from "@/components/util/TimerAccount.vue";
import store from "@/store";
import moment from "moment";
import Util from "../../utils/utils.js";

export default {
  data: () => ({
    rollerPicker: false,
    userName: '',
    birthday: "",
    phone: '',
    authCode: '',
    gender: null,
    Timer: null,
    TimeCounter: 180,
    TimerStr: "03:00",
    disabled: true,
    doSendChk: false,  // 발송성공시
    isBtnAt: false,   // 인증번호 확인버튼 disabled
    isTimeOut: false,   // 인증번호 확인 시간 종료
    btnText: "인증번호 발송",
    codeConfirm: false,  // 코드 확인 결과값
    codeChkReturnMsg: '',  //코드 확인 리턴 메세지
    nextDisabled: true,  // 다음버튼 disabled
    confirmReadonly: false,  // 인증확인 readonly
    successReadonly: false,  // 인증확인 readonly
  }),
  mounted() {
    //division 유실된경우 새로고침등 로그인 페이지로 보냄
    if (this.division == "" || this.division == undefined || this.division == null) {
      window.location.href = '/user/login'
    }

    //기업회원 명부형 로그인->약관동의 로 넘어온경우 clientCd 조회하여 처리
    if (store.getters.clientCd !== '' && store.getters.clientCd !== undefined) {
      this.btnText = "인증번호 발송";
      this.userName = this.memberInfo.userName;
      this.birthday = Util.Date.toDate(this.memberInfo.birthyyMmday);
      this.gender = this.memberInfo.gender;
      this.phone = this.memberInfo.mobileNo;
    }
  },
  components: {
    BlackBtn,
    DateRollerPicker,
    Timer,
  },
  watch: {
    authCode: function (newVal, oldVal) {
      if (newVal !== oldVal && !this.isTimeOut) {
        this.isBtnAt = false;
      }
    },
  },
  computed: {
    memberInfo () {
      return store.getters.member
    },
    joinUser () {
      return store.state.memberJoin.joinUser
    },
    division () {
      return store.state.memberJoin.joinUser.division
    },
    phone_rule() {
      return [
        v => !!v || '휴대폰 번호를 입력해주세요.',
        v => /01[016789][^0][0-9]{2,3}[0-9]{3,4}/.test(v) || '핸드폰번호를 확인 해주세요'
      ]
    },
    birthday_rule() {
      return [
        v => !!v || "생년월일을 입력해주세요.",
        v => !this.isUnder14YearsOld(v) || '만 14세 이상부터 회원가입이 가능합니다.'
      ];
    },
    userName_rule() {
      return [
        v => !!v || '이름(실명)을 입력해주세요.',
        v => !/[~!@#$%^&*()_+|<>?:{}.]/.test(v) || '이름에는 특수문자를 사용할 수 없습니다.',
        v => !/[\s]/.test(v) || '이름에 공백이 입력되었습니다. 다시 입력해주세요.'
      ]
    },
  },
  methods: {
    getClientCd() {
      let clientCd = this.$store.state.auth.authUser.clientCd;
      return clientCd !== undefined;
    },

    // 인증번호 확인
    async checkAuthCode() {
      //성공
      //인증 성공시 수정 불가, 성공시에는 재전송시에도 번호변경 불필요 -- 성공후에 변경하고 싶은경우 휴대전화 변경시에 재인증 절차 로직 구현해야함
      // this.successReadonly = true
      // this.confirmReadonly = true
      // this.nextDisabled = false
      // this.codeConfirm = true
      // this.isBtnAt = true
      // this.codeChkReturnMsg = '인증되었습니다.'
      // this.$refs.timer.timerStop();

      //실패
      // this.confirmReadonly = false  //인증 실패시 휴대폰번호 수정
      // this.nextDisabled = true
      // this.codeConfirm = false
      // this.isBtnAt = true
      // this.codeChkReturnMsg = '인증 번호를 확인해주세요.'

      let query = {
        phone: this.phone,
        authCode: this.authCode,
        authType: 'phone'
      };
      await store.dispatch('checkAuthCode', this.$_payload("param", query))
        .then(res => {
          if (res.success) {
            //인증 성공시 수정 불가, 성공시에는 재전송시에도 번호변경 불필요 -- 성공후에 변경하고 싶은경우 휴대전화 변경시에 재인증 절차 로직 구현해야함
            this.successReadonly = true
            this.confirmReadonly = true
            this.nextDisabled = false
            this.codeConfirm = true
            this.isBtnAt = true
            this.codeChkReturnMsg = '인증되었습니다.'
            this.$refs.timer.timerStop();
          } else {
            this.confirmReadonly = false  //인증 실패시 휴대폰번호 수정
            this.nextDisabled = true
            this.codeConfirm = false
            this.isBtnAt = true
            this.codeChkReturnMsg = '인증 번호를 확인해주세요.'
          }

        })
        .catch(error => {
          console.error(error)
        })
        .finally(() => {
        })

    },
    async doSendAuthCode() {

      // 성공
      // this.successReadonly = false  // 인증확인 후 재전송시 인증값 입력가능
      // this.confirmReadonly = true // 인증번호전송시 휴대전화 수정 불가 처리
      // this.nextDisabled = true  // 다음버튼 disabled 재발송의 경우도 있기에
      // this.doSendChk  = true
      // this.btnText="재발송"
      // this.isBtnAt = false
      // this.isTimeOut = false  // 시간제한초기화
      // this.authCode = ''      // 코드값 초기화
      // this.$refs.timer.timerStop()
      // this.$refs.timer.timerStart()

      const validate = this.$refs.form.validate()
      // console.log(validate)

      if (validate) {
        await store.dispatch('generateSetAuthCode', this.$_payload(null, {phone: this.phone, authType: 'phone'}))
          .then(res => {
            if (res.success) {
              this.successReadonly = false  // 인증확인 후 재전송시 인증값 입력가능
              this.confirmReadonly = true // 인증번호전송시 휴대전화 수정 불가 처리
              this.nextDisabled = true  // 다음버튼 disabled 재발송의 경우도 있기에
              this.doSendChk = true
              this.btnText = "재발송"
              this.isBtnAt = false
              this.isTimeOut = false  // 시간제한초기화
              this.authCode = ''      // 코드값 초기화
              this.$refs.timer.timerStop()
              this.$refs.timer.timerStart()
            }
          })
          .catch(error => {
            console.error(error)
          })
          .finally(() => {
          })
      }

    },
    goNext() {
      if (!this.nextDisabled) {
        let setData = {
          gender: this.gender
          , mobileNo: this.phone
          , userName: this.userName.trim()
          , birthyyMmday: this.birthday.replaceAll("-", "")
        }
        store.commit('setJoinUser', setData)
        this.$router.push({name: '이메일 가입'})
      }
    },
    rollerPickerOpen() {
      if (this.getClientCd() || this.confirmReadonly) {
        return false;
      } else {
        let date = new Date();
        let year = date.getFullYear();
        let month = '12'
        let day = '31'

        if (this.birthday != "") {
          year = this.birthday.replaceAll("-", "").substr(0, 4)
          month = this.birthday.replaceAll("-", "").substr(4, 2)
          day = this.birthday.replaceAll("-", "").substr(6, 2)
        }

        this.$refs.rollerPicker.setFlicking(year, month, day);
      }

    },
    selectValue(year, month, day) {
      this.birthday = year + "-" + month + "-" + day;
    },
    isUnder14YearsOld(birthdate) {
      // 현재 날짜를 가져옵니다.
      const currentDate = moment();
      // 사용자가 입력한 생년월일을 Moment 객체로 변환합니다.
      const userBirthdate = moment(birthdate);
      // 사용자의 나이를 계산합니다.
      const userAge = currentDate.diff(userBirthdate, 'years');
      // 나이가 14세 미만인지 여부를 반환합니다.
      return userAge < 14;
    },
    timeLimit() {
      this.confirmReadonly = false  //인증 실패시 휴대폰번호 수정가능
      this.isTimeOut = true
      this.nextDisabled = true
      this.codeConfirm = false
      this.isBtnAt = true
      this.codeChkReturnMsg = '인증번호 입력 시간이 지났습니다. 다시 진행해주세요.'
    }
  }
}
</script>
<style lang="scss" scoped>
//.lightBlue--text {
//  color: blue;
//}
//
//::v-deep.v-input--radio-group {
//  margin-top: 0;
//  padding-top: 0;
//  flex: 1 1 auto !important;
//
//  .v-input--radio-group__input {
//    gap: 14px;
//  }
//
//  .radio {
//    flex: 1;
//
//    .v-input--selection-controls__input {
//      display: none;
//    }
//
//    .v-label {
//      height: 48px;
//      border: 1px solid #D9D9D9;
//      border-radius: 10px;
//      color: #212529;
//      justify-content: center;
//    }
//
//    &.active {
//      .v-label {
//        background: #000;
//        color: #fff;
//      }
//    }
//  }
//}
//
//.pos-relative {
//  flex: 1 1 auto;
//}
//
//.v-input::v-deep {
//  .v-text-field__details {
//    padding-left: 0;
//  }
//}
//
//.time {
//  position: absolute;
//  right: 8px;
//  top: 14px;
//  color: $color-red;
//  font-size: 14px;
//}
//
//.false-text {
//  color: $color-red;
//}
</style>
